export function customSlugify(text) {
    const result = text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\p{L}\p{N}.-]+/gu, "")
        .replace(/--+/g, "-");
    return encodeURIComponent(result);
}
